/// <amd-module name="Wit/SprintsHub/SprintsView/Utils/StyleUtils" />
import { ICardStyle } from "Wit/ClientWorkItemService/IClientWorkItem";
import { IFieldEntry } from "Wit/Common/Generated/Contracts";
import { ICardFieldDefinition, IStyleRule } from "Wit/SprintsHub/Common/Contracts/Interfaces";

export function getCardStylesFromCardRules(rules: IStyleRule[] | undefined): ICardStyle[] | undefined {
    return rules?.map(rule => ({
        name: rule.name,
        backgroundColor: rule.styles?.["background-color"] ?? "",
        clauses: rule.criteria?.clauses ?? [],
        isEnabled: rule.isEnabled.toString().toLowerCase() === "true",
        titleStyle: {
            isTitleBold: !!rule.styles?.["title-font-weight"],
            isTitleItalicized: !!rule.styles?.["title-font-style"],
            isTitleUnderlined: !!rule.styles?.["title-text-decoration"],
            titleColor: rule.styles?.["title-color"] ?? ""
        }
    }));
}

export function getFieldEntryFromCardModel(fieldDefinitions: ICardFieldDefinition[] | undefined): IFieldEntry[] | undefined {
    return fieldDefinitions?.map(
        field =>
            ({
                id: field.Id,
                isEditable: field.IsEditable,
                isIdentity: field.IsIdentity,
                name: field.Name,
                referenceName: field.ReferenceName,
                type: field.Type
            } as any as IFieldEntry)
    );
}
